import React from 'react';

interface IconCloudUploadProps {
    width?: number;
    height?: number;
    color?: string;
}

const IconCloudUpload: React.FC<IconCloudUploadProps> = ({
    width = 28,
    height = 28,
    color = '#9CA3AF',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M6.39286 15.4289C4.79518 15.4289 3.5 14.4291 3.5 12.9631C3.5 11.4972 4.79518 10.3088 6.39286 10.3088C6.5015 10.3088 6.60875 10.3143 6.71429 10.325V10.3088H6.75407C6.72781 10.1155 6.71429 9.91866 6.71429 9.71889C6.71429 7.11272 9.01682 5 11.8571 5C13.7805 5 15.4573 5.96881 16.3395 7.40361C16.5551 7.37452 16.7756 7.35945 17 7.35945C19.4853 7.35945 21.5 9.20808 21.5 11.4885C21.5 13.3657 20.1348 14.7967 18.2656 15.2684M12.358 19V12.2258M12.358 12.2258L9.40625 15.0196M12.358 12.2258L15.3125 15.0196"
                stroke={color}
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default IconCloudUpload;
